
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special/ibd-uc-cd",
      function () {
        return require("private-next-pages/special/ibd-uc-cd/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special/ibd-uc-cd"])
      });
    }
  